/** A mention is what turns a comment into a Slack alert, so it has to read as one on screen too. */
const MENTION = /(@[\w.-]+)/g;

/**
 * The comment text with each @name wrapped in `.at`, the same on every screen that shows a thread (View Orders,
 * the Ready to Outbound row, the comments hub) [SSD-7216].
 */
export const withMentions = (text: string) =>
  text.split(MENTION).map((part, index) =>
    part.startsWith('@') ? (
      <span className="at" key={`${part}-${index}`}>
        {part}
      </span>
    ) : (
      part
    ),
  );
